import { useContext } from 'react';
import { DocumentContext, UserContext } from '../../context';
import { Landing } from '../../components/skeleton/landing-page';
import { documentationLinks, filterNavLinksForAccess } from '../../helpers';
import { useAllowedNavRoutes } from '../../hooks/useAllowedNavRoutes';
import { useFlags } from '../../hooks';
import { INavLink } from '../../models';

export const DocumentLanding = () => {
  const userContext = useContext(UserContext);
  const { user } = userContext;
  const featureFlags = useFlags();
  const { availableLinks } = useAllowedNavRoutes(featureFlags, user);
  const { selectedDocumentTab, setSelectedDocumentTab } = useContext(DocumentContext);
  const filteredLinks: INavLink[] = filterNavLinksForAccess(
    documentationLinks,
    userContext,
    featureFlags,
    availableLinks
  );

  return (
    <Landing
      title={'Documents Home'}
      selectedTab={selectedDocumentTab}
      setSelectedTab={setSelectedDocumentTab}
      landingLinks={filteredLinks}
    ></Landing>
  );
};
